/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppEnvironmentStrictHttpResponse } from '../../app-environment-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVivaScoreRequestModel } from '../../models/get-viva-score-request-model';

export interface AppEnvironmentGetVivaScoreAsyncPost$Params {
      body?: GetVivaScoreRequestModel
}

export function appEnvironmentGetVivaScoreAsyncPost(http: HttpClient, rootUrl: string, params?: AppEnvironmentGetVivaScoreAsyncPost$Params, context?: HttpContext): Observable<AppEnvironmentStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, appEnvironmentGetVivaScoreAsyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AppEnvironmentStrictHttpResponse<string>;
    })
  );
}

appEnvironmentGetVivaScoreAsyncPost.PATH = '/AppEnvironment/GetVivaScoreAsync';
